import { plural } from '@cian/utils';

import { NBSP } from '../../constants';
import { NEW_OBJECT_VARIANTS } from '../../interfaces/village';

export function getTooltipItem(value: number, type: string, notLast: boolean = true) {
  return `${value}${NBSP}${plural(value, NEW_OBJECT_VARIANTS[type])}${notLast ? '  ·  ' : ''}`;
}
